import React from 'react';
import moment from 'moment';

export default function DetailComponent({ data }) {
  return <div className="row">
    <div className="col-lg-4">
      <ul className="list-group list-group-flush">
        <li className="list-group-item"><strong>ID:</strong> {data.intakeId}</li>
      </ul>
    </div>
    <div className="col-lg-4">
      <ul className="list-group list-group-flush">
        <li className="list-group-item"><strong>Started:</strong> {moment.tz(data.scheduledAt.date, data.scheduledAt.timezone).local().format('l LT')}</li>

        {data.uploadedAt && <li className="list-group-item"><strong>EHR Uploaded:</strong> {moment.tz(data.uploadedAt.date, data.uploadedAt.timezone).local().format('l LT')}</li>}
      </ul>
    </div>
  </div>
}